import React, { FC } from 'react';
import { asStyledComponent } from '@cld/component-enhancer';
import { FoundationContextProvider } from '@cld/design-system-foundations';
import { ChipProps } from './types';
import { LeftWrapper, RightWrapper, Root } from './Chip.styled';
import { useFoundation, useSurface } from './foundationMapping';

/** The purpose of this component is to display text within a small chip / pill. May be wrapped with `ChipList` */
export const Chip = asStyledComponent<FC<ChipProps>>(
  ({ isHoverable = false, isSelected = false, tone, variant, size, label, leftSlot, rightSlot, rootProps, dataTest, ...rest }) => {
    const foundation = useFoundation({ size });
    const surface = useSurface({ variant, tone });

    return (
      <Root
        as={isHoverable ? 'button' : 'div'}
        isHoverable={isHoverable}
        isSelected={isSelected}
        {...surface.componentProps}
        {...foundation.componentProps}
        {...rootProps}
        {...rest}
        data-test={dataTest}
      >
        <FoundationContextProvider {...foundation.innerContextProps}>
          <LeftWrapper>{leftSlot}</LeftWrapper>
          {label}
          <RightWrapper>{rightSlot}</RightWrapper>
        </FoundationContextProvider>
      </Root>
    );
  }
);
